import { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';

declare module 'axios' {
  interface AxiosError {
    traceId?: string;
  }
}

// Generates W3C trace context
function generateTraceparent(): string {
  const traceId = crypto.randomUUID().replace(/-/g, '');
  const parentId = crypto.randomUUID().replace(/-/g, '').slice(0, 16);
  return `00-${traceId}-${parentId}-01`;
}

const traceRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  config.headers['traceparent'] ??= generateTraceparent();
  return config;
};

const traceUnhandledErrorInterceptor = (error: AxiosError) => {
  error.traceId = error.config?.headers?.['traceparent'] as string | undefined;
  return Promise.reject(error);
};

export function addTraceInterceptor(axiosInstance: AxiosInstance): void {
  axiosInstance.interceptors.request.use(traceRequestInterceptor);
  axiosInstance.interceptors.response.use(
    undefined,
    traceUnhandledErrorInterceptor,
  );
}
